import React, { useEffect, useRef, useState } from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../label-custom'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { updateEducationAPI } from '../../../services/education'
import Autocomplete from '../../custom/autocomplete'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import { deleteEducationAPI } from '../../../services/education'
import SwalCustom from '../../../alert/swal-custom'
import UseEducationTypes from '../../../hooks/use-education-type'
import { TXTSUCCESS } from '../../../Constants'
import useNumberInput from '../../../helper/input-fix-num'

const schema = yup
  .object({
    eduType: yup.object().required('Please, Fill Education Degree'),
    eduQual: yup.string().required('Please, Fill Educational Qualification'),
    eduName: yup.string().required('Please, Fill Institution Name'),
    adYear: yup
      .string()
      .required('Please, Fill Start Year')
      .test(
        'is-gradYear-after-adYear',
        'Pleace, re-check Start Year and Graduated Year again',
        function (value) {
          const gradYear = this.parent.gradYear
          if (!gradYear) return true // Skip validation if gradYear is not set
          return parseInt(value) <= parseInt(gradYear)
        }
      ),
    gradYear: yup.string().required('Please, Fill Graduated Year'),
    eduBg: yup.string().required('Please, Fill Faculty'),
    major: yup.string().required('Please, Fill Major'),
    grade: yup.string().required('Please, Fill Grade')
  })
  .required()

export default function EditEducationHistory({
  param,
  setIsSave,
  showCreate,
  isSave,
  fnGetWorks,
  setShowCreate,
  detail
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [adYear, setAdYear] = useState(null)

  const [disableYearStart, setDisableYearStart] = useState(null)
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  useEffect(() => {
    currentYear()
  }, [showCreate])

  const currentYear = () => {
    const d = new Date()
    let year = d.getFullYear()
    setDisableYearStart(year)
  }

  useEffect(() => {
    setValue(
      'eduType',
      { value: detail?.edu_type_id, label: detail?.education } ?? ''
    )
    setError('company', false)

    setValue('eduName', detail?.edu_name ?? '')
    setError('eduName', false)

    setValue('eduQual', detail?.qualification ?? '')
    setError('eduQual', false)

    setValue('duty', detail?.duty ?? '')
    setError('duty', false)

    setValue('adYear', detail?.admission_year ?? '')
    setError('adYear', false)
    setValue('gradYear', detail?.graduation_year ?? '')
    setError('gradYear', false)

    setValue('eduBg', detail?.edu_bg ?? '')
    setError('eduBg', false)

    setValue('major', detail?.major ?? '')
    setError('major', false)

    setValue('grade', detail?.grade ?? '')
    setError('grade', false)
  }, [
    detail?.admission_year,
    detail?.duty,
    detail?.edu_bg,
    detail?.edu_name,
    detail?.edu_type_id,
    detail?.education,
    detail?.grade,
    detail?.graduation_year,
    detail?.major,
    setError,
    setValue
  ])
  const educationTypes = UseEducationTypes()

  const onSubmit = async (d) => {
    setIsSave(true)
    const data = {
      eduTypeId: d?.eduType.value,
      qualification: d?.eduQual,
      eduName: d?.eduName,
      adYear: d?.adYear,
      gradYear: d?.gradYear,
      eduBg: d?.eduBg,
      major: d?.major,
      grade: d?.grade
    }
    const params = { ...param, educationId: detail?.id }

    createWorks(params, data)
  }
  const createWorks = async (params, body) => {
    try {
      const data = await updateEducationAPI(params, body)
      if (data?.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          handleClose()
          fnGetWorks()
          fnReset()
        })
      } else {
        Error_false(data)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }
  const fnReset = () => {
    setError('eduType', false)
    setError('eduQual', false)
    setError('eduName', false)
    setError('adYear', false)
    setError('gradYear', false)
    setError('eduBg', false)
    setError('major', false)
    setError('grade', false)
  }
  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }
  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to delete this?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        delEducation()
      }
    })
  }

  const delEducation = async () => {
    try {
      const res = await deleteEducationAPI({ ...param, educationId: detail.id })
      if (res.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          setIsSave(false)
          handleClose()
          fnGetWorks()
          fnReset()
        })
      } else {
        setIsSave(false)
        Error_false(res)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }
  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Education History</label>
        <Col md={12}>
          <LabelCustom text={'Education Degree'} />
          <Controller
            name={'eduType'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                options={educationTypes}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.eduType?.message && (
            <label className="small text-danger">
              {errors.eduType.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Institution Name'} />
          <Controller
            name={'eduName'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.eduName?.message && (
            <label className="small text-danger">
              {errors.eduName.message}
            </label>
          )}
        </Col>

        <Col xl={6}>
          <LabelCustom text="Start (พ.ศ.)" />
          <Controller
            name={'adYear'}
            control={control}
            render={({ field: { value } }) => (
              <Form.Control
                maxLength={4}
                value={value}
                onKeyDown={handleKeyDownNum}
                onChange={(e) => {
                  setValue('adYear', e.target.value)
                  setAdYear(e.target.value)
                  setError('adYear', false)
                }}
              />
              // <DatePicker
              //   style={{ fontFamily: 'Sarabun' }}
              //   defaultValue={
              //     detail?.admission_year
              //       ? dayjs(detail?.admission_year, 'YYYY')
              //       : ''
              //   }
              //   className="form-control"
              //   onChange={(date, dateString) => {
              //     setValue('adYear', dateString)
              //     setAdYear(dateString)
              //     setError('adYear', date)
              //     setDisableYear(dateString)
              //   }}
              //   picker="year"
              //   disabledDate={(current) =>
              //     current &&
              //     disableYearEnd &&
              //     disableYearStart >= disableYearEnd
              //       ? current.year() > parseInt(disableYearEnd)
              //       : disableYearStart &&
              //         current.year() > parseInt(disableYearStart)
              //   }
              // />
            )}
          />

          {errors.adYear?.message && (
            <label className="small text-danger">{errors.adYear.message}</label>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text="To (พ.ศ.)" />
          <Controller
            name={'gradYear'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Form.Control
                maxLength={4}
                value={value}
                onKeyDown={handleKeyDownNum}
                onChange={(e) => {
                  setValue('gradYear', e.target.value)
                  setError('gradYear', false)
                }}
              />
              // <DatePicker
              //   style={{ fontFamily: 'Sarabun' }}
              //   defaultValue={
              //     detail?.graduation_year
              //       ? dayjs(detail?.graduation_year, 'YYYY')
              //       : ''
              //   }
              //   className="form-control"
              //   onChange={(date, dateString) => {
              //     setValue('gradYear', dateString)
              //     setError('gradYear', dateString)
              //     setDisableYearEnd(dateString)
              //   }}
              //   picker="year"
              //   // disabledDate={(current) =>
              //   //   current && current.year() < parseInt(adYear)
              //   // }
              //   disabledDate={(current) =>
              //     current &&
              //     disableYear &&
              //     current.year() < parseInt(disableYear)
              //   }
              // />
            )}
          />
          {errors.gradYear?.message && (
            <label className="small text-danger">
              {errors.gradYear.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <LabelCustom text={'Educational Qualification'} />
          <Controller
            name={'eduQual'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.eduQual?.message && (
            <label className="small text-danger">
              {errors.eduQual.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <LabelCustom text={'Faculty'} />
          <Controller
            name={'eduBg'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.eduBg?.message && (
            <label className="small text-danger">{errors.eduBg.message}</label>
          )}
        </Col>
        <Col xl={12}>
          <LabelCustom text="Major" />
          <Controller
            name={'major'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.major?.message && (
            <label className="small text-danger">{errors.major.message}</label>
          )}
        </Col>

        <Col xl={12}>
          <LabelCustom text="Grade" />
          <Controller
            name={'grade'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.grade?.message && (
            <label className="small text-danger">{errors.grade.message}</label>
          )}
        </Col>
        <Col xl={12} className="text-center mt-3">
          <Button
            className="px-4 me-2"
            variant="danger"
            type="button"
            disabled={isSave}
            onClick={fnDelete}
            size="sm"
          >
            Delete
          </Button>
          <Button
            className="px-4 text-primary me-2"
            variant="light"
            type="button"
            disabled={isSave}
            onClick={handleClose}
            size="sm"
          >
            Close
          </Button>
          <Button className="px-4 " disabled={isSave} type="submit" size="sm">
            {isSave ? 'Saving......' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
